/* tslint:disable */
/* eslint-disable */
/**
 * SupplierForecastManage API
 * 仕入先内示の情報を操作するやつ
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Excelファイルに出力する情報のベースとなる集計取引情報
 * @export
 * @interface AggregateBusinessExportData
 */
export interface AggregateBusinessExportData {
    /**
     * 組織ID
     * @type {string}
     * @memberof AggregateBusinessExportData
     */
    'organizationId'?: string;
    /**
     * 集計取引ID
     * @type {string}
     * @memberof AggregateBusinessExportData
     */
    'aggregateBusinessId': string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof AggregateBusinessExportData
     */
    'supplierNumber': string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof AggregateBusinessExportData
     */
    'supplierName': string;
    /**
     * 商品CD
     * @type {string}
     * @memberof AggregateBusinessExportData
     */
    'businessNumber': string;
    /**
     * 商品名
     * @type {string}
     * @memberof AggregateBusinessExportData
     */
    'businessName': string;
    /**
     * 置場CD
     * @type {string}
     * @memberof AggregateBusinessExportData
     */
    'warehouseNumber': string;
    /**
     * 置場名
     * @type {string}
     * @memberof AggregateBusinessExportData
     */
    'warehouse': string;
    /**
     * 容量
     * @type {number}
     * @memberof AggregateBusinessExportData
     */
    'package': number;
    /**
     * 
     * @type {SalesResultSummaryExportData}
     * @memberof AggregateBusinessExportData
     */
    'SalesResult'?: SalesResultSummaryExportData;
    /**
     * 仕入先内示の詳細情報
     * @type {Array<SupplierAnnounceExportData>}
     * @memberof AggregateBusinessExportData
     */
    'SupplierForecasts': Array<SupplierAnnounceExportData>;
}
/**
 * 
 * @export
 * @interface BulkPostSupplierForecastByCustomerForecastRequest
 */
export interface BulkPostSupplierForecastByCustomerForecastRequest {
    /**
     * upsert処理を実行するかどうかのフラグ
     * @type {boolean}
     * @memberof BulkPostSupplierForecastByCustomerForecastRequest
     */
    'useUpsert': boolean;
    /**
     * 
     * @type {BulkPostSupplierForecastByCustomerForecastRequestInfo}
     * @memberof BulkPostSupplierForecastByCustomerForecastRequest
     */
    'bulkPostSupplierForecastByCustomerForecastRequestInfo': BulkPostSupplierForecastByCustomerForecastRequestInfo;
}
/**
 * 客先内示から仕入先内示を登録する際に渡す情報
 * @export
 * @interface BulkPostSupplierForecastByCustomerForecastRequestInfo
 */
export interface BulkPostSupplierForecastByCustomerForecastRequestInfo {
    /**
     * 
     * @type {number}
     * @memberof BulkPostSupplierForecastByCustomerForecastRequestInfo
     */
    'receive-year': number;
    /**
     * 
     * @type {number}
     * @memberof BulkPostSupplierForecastByCustomerForecastRequestInfo
     */
    'receive-month': number;
    /**
     * 
     * @type {Array<YearMonth>}
     * @memberof BulkPostSupplierForecastByCustomerForecastRequestInfo
     */
    'targetYearMonthList'?: Array<YearMonth>;
    /**
     * 
     * @type {CustomerForecastFilterItem}
     * @memberof BulkPostSupplierForecastByCustomerForecastRequestInfo
     */
    'customerForecastFilterItem'?: CustomerForecastFilterItem;
}
/**
 * 
 * @export
 * @interface BulkPostSupplierForecastRequest
 */
export interface BulkPostSupplierForecastRequest {
    /**
     * upsert処理を実行するかどうかのフラグ
     * @type {boolean}
     * @memberof BulkPostSupplierForecastRequest
     */
    'useUpsert': boolean;
    /**
     * 仕入先内示情報登録(bulk)で渡す仕入先内示情報の型
     * @type {Array<PostSupplierForecastRequestInfo>}
     * @memberof BulkPostSupplierForecastRequest
     */
    'bulkPostSupplierForecastInfo': Array<PostSupplierForecastRequestInfo>;
}
/**
 * postした時にレスポンスで受け取る情報の型定義
 * @export
 * @interface BulkPostSupplierForecastResponse
 */
export interface BulkPostSupplierForecastResponse {
    /**
     * 
     * @type {number}
     * @memberof BulkPostSupplierForecastResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof BulkPostSupplierForecastResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof BulkPostSupplierForecastResponse
     */
    'message': string;
    /**
     * 
     * @type {BulkSupplierForecastResponseInfo}
     * @memberof BulkPostSupplierForecastResponse
     */
    'result': BulkSupplierForecastResponseInfo;
}
/**
 * 仕入先内示(bulk)のレスポンス
 * @export
 * @interface BulkSupplierForecastResponseInfo
 */
export interface BulkSupplierForecastResponseInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkSupplierForecastResponseInfo
     */
    'data': Array<string>;
}
/**
 * リクエストに含めるフィルター項目の型
 * @export
 * @interface CustomerForecastFilterItem
 */
export interface CustomerForecastFilterItem {
    /**
     * 集計取引ID
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'aggregateBusinessId'?: string;
    /**
     * 関連取引ID
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'baseBusinessId'?: string;
    /**
     * 関連取引担当者ID
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'baseBusienssResponsibleUserId'?: string;
    /**
     * 置場CD
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'warehouseNumber'?: string;
    /**
     * 置場名
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'warehouse'?: string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'supplierNumber'?: string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'supplierName'?: string;
    /**
     * 商品CD
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'businessNumber'?: string;
    /**
     * 商品名
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'businessName'?: string;
    /**
     * 容量
     * @type {number}
     * @memberof CustomerForecastFilterItem
     */
    'package'?: number;
    /**
     * 単位
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'unit'?: string;
    /**
     * 製造社
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'manufacturer'?: string;
    /**
     * 売上先CD
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'customerNumber'?: string;
    /**
     * 売上先名
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'customerName'?: string;
    /**
     * 送り先CD
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'salesDestinationNumber'?: string;
    /**
     * 送り先名
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'salesDestinationName'?: string;
    /**
     * エンドユーザー
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'endUser'?: string;
    /**
     * 受領用内示ID
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'forecastForReceiptId'?: string;
    /**
     * 受領用内示担当者ID
     * @type {string}
     * @memberof CustomerForecastFilterItem
     */
    'forecastForReceiptResponsibleUserId'?: string;
}
/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 * 
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     * 
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 * Excelファイルに出力する情報の型定義
 * @export
 * @interface GetExportDataResponse
 */
export interface GetExportDataResponse {
    /**
     * 
     * @type {number}
     * @memberof GetExportDataResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetExportDataResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetExportDataResponse
     */
    'message': string;
    /**
     * 
     * @type {GetExportDataResponseAllOfResult}
     * @memberof GetExportDataResponse
     */
    'result': GetExportDataResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetExportDataResponseAllOfResult
 */
export interface GetExportDataResponseAllOfResult {
    /**
     * 
     * @type {GetExportDataResponseData}
     * @memberof GetExportDataResponseAllOfResult
     */
    'data': GetExportDataResponseData;
}
/**
 * Excelファイルに出力する情報の型定義
 * @export
 * @interface GetExportDataResponseData
 */
export interface GetExportDataResponseData {
    /**
     * 出力用Excelの本体(base64エンコードされた文字列)
     * @type {string}
     * @memberof GetExportDataResponseData
     */
    'excelFile': string;
    /**
     * 出力する仕入先内示情報
     * @type {Array<AggregateBusinessExportData>}
     * @memberof GetExportDataResponseData
     */
    'supplierForecasts': Array<AggregateBusinessExportData>;
}
/**
 * 仕入先内示の一覧を返すレスポンス
 * @export
 * @interface GetSupplierForecastResponse
 */
export interface GetSupplierForecastResponse {
    /**
     * 
     * @type {number}
     * @memberof GetSupplierForecastResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetSupplierForecastResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetSupplierForecastResponse
     */
    'message': string;
    /**
     * 
     * @type {GetSupplierForecastResponseAllOfResult}
     * @memberof GetSupplierForecastResponse
     */
    'result': GetSupplierForecastResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface GetSupplierForecastResponseAllOfResult
 */
export interface GetSupplierForecastResponseAllOfResult {
    /**
     * 仕入先内示関連情報
     * @type {Array<SupplierForecastDataInner>}
     * @memberof GetSupplierForecastResponseAllOfResult
     */
    'data': Array<SupplierForecastDataInner>;
    /**
     * 
     * @type {PagingOptions}
     * @memberof GetSupplierForecastResponseAllOfResult
     */
    'pagingOptions': PagingOptions;
}
/**
 * APIから受け取るpagingOptionsの情報
 * @export
 * @interface PagingOptions
 */
export interface PagingOptions {
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'offset': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'nextOffset': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'totalResultsAvailable': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'returnCount': number;
}
/**
 * 
 * @export
 * @interface PostSupplierForecastRequest
 */
export interface PostSupplierForecastRequest {
    /**
     * 
     * @type {PostSupplierForecastRequestInfo}
     * @memberof PostSupplierForecastRequest
     */
    'postSupplierForecastInfo'?: PostSupplierForecastRequestInfo;
}
/**
 * 仕入先内示登録で投げる仕入先内示情報
 * @export
 * @interface PostSupplierForecastRequestInfo
 */
export interface PostSupplierForecastRequestInfo {
    /**
     * 
     * @type {string}
     * @memberof PostSupplierForecastRequestInfo
     */
    'aggregateBusinessId': string;
    /**
     * 
     * @type {number}
     * @memberof PostSupplierForecastRequestInfo
     */
    'supplierForecastCreatedYear': number;
    /**
     * 
     * @type {number}
     * @memberof PostSupplierForecastRequestInfo
     */
    'supplierForecastCreatedMonth': number;
    /**
     * 
     * @type {number}
     * @memberof PostSupplierForecastRequestInfo
     */
    'supplierForecastTargetYear': number;
    /**
     * 
     * @type {number}
     * @memberof PostSupplierForecastRequestInfo
     */
    'supplierForecastTargetMonth': number;
    /**
     * 
     * @type {number}
     * @memberof PostSupplierForecastRequestInfo
     */
    'supplierForecastAmount': number;
    /**
     * 
     * @type {string}
     * @memberof PostSupplierForecastRequestInfo
     */
    'supplierForecastResponsibleUserIdHistory'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostSupplierForecastRequestInfo
     */
    'supplierForecastResponsibleUserNameHistory'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostSupplierForecastRequestInfo
     */
    'equalCustomerForecastDataFlag': boolean;
}
/**
 * postした時にレスポンスで受け取る情報の型定義
 * @export
 * @interface PostSupplierForecastResponse
 */
export interface PostSupplierForecastResponse {
    /**
     * 
     * @type {number}
     * @memberof PostSupplierForecastResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PostSupplierForecastResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PostSupplierForecastResponse
     */
    'message': string;
    /**
     * 
     * @type {PostSupplierForecastResponseResult}
     * @memberof PostSupplierForecastResponse
     */
    'result': PostSupplierForecastResponseResult;
}
/**
 * 仕入先内示登録APIのレスポンスの型定義
 * @export
 * @interface PostSupplierForecastResponseResult
 */
export interface PostSupplierForecastResponseResult {
    /**
     * 
     * @type {string}
     * @memberof PostSupplierForecastResponseResult
     */
    'supplierForecastId': string;
}
/**
 * 
 * @export
 * @interface PutSupplierForecastResponsibleUserIdRequest
 */
export interface PutSupplierForecastResponsibleUserIdRequest {
    /**
     * 更新対象の集計ID（複数指定可能）
     * @type {Array<string>}
     * @memberof PutSupplierForecastResponsibleUserIdRequest
     */
    'targetAggregateBusinessIdList'?: Array<string>;
    /**
     * 更新する担当者IDのリスト
     * @type {Array<string>}
     * @memberof PutSupplierForecastResponsibleUserIdRequest
     */
    'aggregateBusinessUserIdList': Array<string>;
}
/**
 * 仕入先内示の担当者情報更新APIのレスポンスの型定義
 * @export
 * @interface PutSupplierForecastResponsibleUserIdResponse
 */
export interface PutSupplierForecastResponsibleUserIdResponse {
    /**
     * 
     * @type {number}
     * @memberof PutSupplierForecastResponsibleUserIdResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PutSupplierForecastResponsibleUserIdResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PutSupplierForecastResponsibleUserIdResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof PutSupplierForecastResponsibleUserIdResponse
     */
    'result': object;
}
/**
 * 販売実績のサマリ情報(出力用)
 * @export
 * @interface SalesResultSummaryExportData
 */
export interface SalesResultSummaryExportData {
    /**
     * 販売実績サマリID
     * @type {string}
     * @memberof SalesResultSummaryExportData
     */
    'salesResultSummaryId': string;
    /**
     * 販売実績対象年
     * @type {number}
     * @memberof SalesResultSummaryExportData
     */
    'salesResultTargetYear': number;
    /**
     * 販売実績対象月
     * @type {number}
     * @memberof SalesResultSummaryExportData
     */
    'salesResultTargetMonth': number;
    /**
     * 販売数量
     * @type {number}
     * @memberof SalesResultSummaryExportData
     */
    'salesResultAmountTotal': number;
}
/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}
/**
 * 仕入先内示の詳細情報(出力用)
 * @export
 * @interface SupplierAnnounceExportData
 */
export interface SupplierAnnounceExportData {
    /**
     * 仕入先内示ID
     * @type {string}
     * @memberof SupplierAnnounceExportData
     */
    'supplierForecastId': string;
    /**
     * 「= 客先内示」にチェックを入れて作成されたかどうか
     * @type {boolean}
     * @memberof SupplierAnnounceExportData
     */
    'equalCustomerForecastDataFlag': boolean;
    /**
     * 仕入先内示作成年
     * @type {number}
     * @memberof SupplierAnnounceExportData
     */
    'supplierForecastCreatedYear': number;
    /**
     * 仕入先内示作成月
     * @type {number}
     * @memberof SupplierAnnounceExportData
     */
    'supplierForecastCreatedMonth': number;
    /**
     * 仕入先内示対象年
     * @type {number}
     * @memberof SupplierAnnounceExportData
     */
    'supplierForecastTargetYear': number;
    /**
     * 仕入先内示対象月
     * @type {number}
     * @memberof SupplierAnnounceExportData
     */
    'supplierForecastTargetMonth': number;
    /**
     * 仕入先内示数量
     * @type {number}
     * @memberof SupplierAnnounceExportData
     */
    'supplierForecastAmount': number;
}
/**
 * 仕入先内示情報
 * @export
 * @interface SupplierForecast
 */
export interface SupplierForecast {
    /**
     * 
     * @type {string}
     * @memberof SupplierForecast
     */
    'supplierForecastId': string;
    /**
     * 
     * @type {string}
     * @memberof SupplierForecast
     */
    'aggregateBusinessId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SupplierForecast
     */
    'supplierForecastCreatedYear': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierForecast
     */
    'supplierForecastCreatedMonth': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierForecast
     */
    'supplierForecastTargetYear': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierForecast
     */
    'supplierForecastTargetMonth': number;
    /**
     * 
     * @type {number}
     * @memberof SupplierForecast
     */
    'supplierForecastAmount': number;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierForecast
     */
    'equalCustomerForecastDataFlag': boolean;
    /**
     * 
     * @type {number}
     * @memberof SupplierForecast
     */
    'updateAt': number;
}
/**
 * 
 * @export
 * @interface SupplierForecastDataInner
 */
export interface SupplierForecastDataInner {
    /**
     * 関連取引ID
     * @type {string}
     * @memberof SupplierForecastDataInner
     */
    'aggregateBusinessId': string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof SupplierForecastDataInner
     */
    'aggregateBusinessResponsibleUsers'?: Array<UserData>;
    /**
     * 置場CD
     * @type {string}
     * @memberof SupplierForecastDataInner
     */
    'warehouseNumber'?: string;
    /**
     * 置場名
     * @type {string}
     * @memberof SupplierForecastDataInner
     */
    'warehouse': string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof SupplierForecastDataInner
     */
    'supplierNumber'?: string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof SupplierForecastDataInner
     */
    'supplierName': string;
    /**
     * 商品CD
     * @type {string}
     * @memberof SupplierForecastDataInner
     */
    'businessNumber': string;
    /**
     * 商品名
     * @type {string}
     * @memberof SupplierForecastDataInner
     */
    'businessName'?: string;
    /**
     * 容量
     * @type {number}
     * @memberof SupplierForecastDataInner
     */
    'package': number;
    /**
     * 単位
     * @type {string}
     * @memberof SupplierForecastDataInner
     */
    'unit'?: string;
    /**
     * 製造社
     * @type {string}
     * @memberof SupplierForecastDataInner
     */
    'manufacturer'?: string;
    /**
     * 仕入先内示の詳細情報
     * @type {Array<SupplierForecast>}
     * @memberof SupplierForecastDataInner
     */
    'supplierForecasts': Array<SupplierForecast>;
}
/**
 * リクエストに含めるフィルター項目の型
 * @export
 * @interface SupplierForecastFilterItem
 */
export interface SupplierForecastFilterItem {
    /**
     * 集計取引ID
     * @type {string}
     * @memberof SupplierForecastFilterItem
     */
    'aggregateBusinessId'?: string;
    /**
     * 集計取引担当者ID
     * @type {string}
     * @memberof SupplierForecastFilterItem
     */
    'aggregateBusinessResponsibleUserId'?: string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof SupplierForecastFilterItem
     */
    'supplierCode'?: string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof SupplierForecastFilterItem
     */
    'supplierName'?: string;
    /**
     * 商品CD
     * @type {string}
     * @memberof SupplierForecastFilterItem
     */
    'businessNumber'?: string;
    /**
     * 商品名
     * @type {string}
     * @memberof SupplierForecastFilterItem
     */
    'businessName'?: string;
    /**
     * 容量
     * @type {number}
     * @memberof SupplierForecastFilterItem
     */
    'package'?: number;
    /**
     * 置場CD
     * @type {string}
     * @memberof SupplierForecastFilterItem
     */
    'warehouseCode'?: string;
    /**
     * 置場
     * @type {string}
     * @memberof SupplierForecastFilterItem
     */
    'warehouse'?: string;
    /**
     * 単位
     * @type {string}
     * @memberof SupplierForecastFilterItem
     */
    'unit'?: string;
    /**
     * 製造社
     * @type {string}
     * @memberof SupplierForecastFilterItem
     */
    'manufacturer'?: string;
}
/**
 * ユーザーデータ
 * @export
 * @interface UserData
 */
export interface UserData {
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'name'?: string;
}
/**
 * 年月情報
 * @export
 * @interface YearMonth
 */
export interface YearMonth {
    /**
     * 
     * @type {number}
     * @memberof YearMonth
     */
    'year': number;
    /**
     * 
     * @type {number}
     * @memberof YearMonth
     */
    'month': number;
}

/**
 * SupplierForecastApi - axios parameter creator
 * @export
 */
export const SupplierForecastApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Excelファイルに出力する情報を取得する(bulk)
         * @param {number} targetStartYear 対象開始年
         * @param {number} targetStartMonth 対象開始月
         * @param {number} targetEndYear 対象終了年
         * @param {number} targetEndMonth 対象終了月
         * @param {SupplierForecastFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSupplierForecastExportData: async (targetStartYear: number, targetStartMonth: number, targetEndYear: number, targetEndMonth: number, filterItem?: SupplierForecastFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetStartYear' is not null or undefined
            assertParamExists('bulkGetSupplierForecastExportData', 'targetStartYear', targetStartYear)
            // verify required parameter 'targetStartMonth' is not null or undefined
            assertParamExists('bulkGetSupplierForecastExportData', 'targetStartMonth', targetStartMonth)
            // verify required parameter 'targetEndYear' is not null or undefined
            assertParamExists('bulkGetSupplierForecastExportData', 'targetEndYear', targetEndYear)
            // verify required parameter 'targetEndMonth' is not null or undefined
            assertParamExists('bulkGetSupplierForecastExportData', 'targetEndMonth', targetEndMonth)
            const localVarPath = `/supplier-forecast/export-data/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (targetStartYear !== undefined) {
                localVarQueryParameter['target-start-year'] = targetStartYear;
            }

            if (targetStartMonth !== undefined) {
                localVarQueryParameter['target-start-month'] = targetStartMonth;
            }

            if (targetEndYear !== undefined) {
                localVarQueryParameter['target-end-year'] = targetEndYear;
            }

            if (targetEndMonth !== undefined) {
                localVarQueryParameter['target-end-month'] = targetEndMonth;
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 仕入先内示テーブルに情報を登録する(bulk)
         * @param {BulkPostSupplierForecastRequest} bulkPostSupplierForecastRequest 登録する仕入先内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkPostSupplierForecast: async (bulkPostSupplierForecastRequest: BulkPostSupplierForecastRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkPostSupplierForecastRequest' is not null or undefined
            assertParamExists('bulkPostSupplierForecast', 'bulkPostSupplierForecastRequest', bulkPostSupplierForecastRequest)
            const localVarPath = `/supplier-forecast/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkPostSupplierForecastRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 客先内示情報を基に仕入先内示テーブルに情報を登録する
         * @param {BulkPostSupplierForecastByCustomerForecastRequest} bulkPostSupplierForecastByCustomerForecastRequest 登録する仕入先内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkPostSupplierForecastByCustomerForecast: async (bulkPostSupplierForecastByCustomerForecastRequest: BulkPostSupplierForecastByCustomerForecastRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkPostSupplierForecastByCustomerForecastRequest' is not null or undefined
            assertParamExists('bulkPostSupplierForecastByCustomerForecast', 'bulkPostSupplierForecastByCustomerForecastRequest', bulkPostSupplierForecastByCustomerForecastRequest)
            const localVarPath = `/supplier-forecast/by-customer-forecast/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkPostSupplierForecastByCustomerForecastRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 仕入先内示情報テーブルから情報の取得を行う
         * @param {GetSupplierForecastSortTypeEnum} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {number} createdYear 仕入先内示作成年
         * @param {number} createdMonth 仕入先内示作成月
         * @param {string} [sortTarget] どこの列をソート対象にするのかを指定するパラメータ
         * @param {SupplierForecastFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {boolean} [unassignedResponsibleUserFlag] 客先内示固有 担当者未割り当て（検索用）フラグ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierForecast: async (sortType: GetSupplierForecastSortTypeEnum, limit: number, offset: number, createdYear: number, createdMonth: number, sortTarget?: string, filterItem?: SupplierForecastFilterItem, unassignedResponsibleUserFlag?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sortType' is not null or undefined
            assertParamExists('getSupplierForecast', 'sortType', sortType)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getSupplierForecast', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getSupplierForecast', 'offset', offset)
            // verify required parameter 'createdYear' is not null or undefined
            assertParamExists('getSupplierForecast', 'createdYear', createdYear)
            // verify required parameter 'createdMonth' is not null or undefined
            assertParamExists('getSupplierForecast', 'createdMonth', createdMonth)
            const localVarPath = `/supplier-forecast`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (createdYear !== undefined) {
                localVarQueryParameter['created-year'] = createdYear;
            }

            if (createdMonth !== undefined) {
                localVarQueryParameter['created-month'] = createdMonth;
            }

            if (sortTarget !== undefined) {
                localVarQueryParameter['sort_target'] = sortTarget;
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (unassignedResponsibleUserFlag !== undefined) {
                localVarQueryParameter['unassigned-responsible-user-flag'] = unassignedResponsibleUserFlag;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 仕入先内示テーブルに情報を登録する
         * @param {PostSupplierForecastRequest} postSupplierForecastRequest 登録する仕入先内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSupplierForecast: async (postSupplierForecastRequest: PostSupplierForecastRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postSupplierForecastRequest' is not null or undefined
            assertParamExists('postSupplierForecast', 'postSupplierForecastRequest', postSupplierForecastRequest)
            const localVarPath = `/supplier-forecast`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postSupplierForecastRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 仕入先内示テーブルの担当者情報を更新する
         * @param {PutSupplierForecastResponsibleUserIdRequest} putSupplierForecastResponsibleUserIdRequest 更新する仕入先内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSupplierForecastResponsibleUserId: async (putSupplierForecastResponsibleUserIdRequest: PutSupplierForecastResponsibleUserIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'putSupplierForecastResponsibleUserIdRequest' is not null or undefined
            assertParamExists('putSupplierForecastResponsibleUserId', 'putSupplierForecastResponsibleUserIdRequest', putSupplierForecastResponsibleUserIdRequest)
            const localVarPath = `/supplier-forecast/responsible-user-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putSupplierForecastResponsibleUserIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupplierForecastApi - functional programming interface
 * @export
 */
export const SupplierForecastApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupplierForecastApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Excelファイルに出力する情報を取得する(bulk)
         * @param {number} targetStartYear 対象開始年
         * @param {number} targetStartMonth 対象開始月
         * @param {number} targetEndYear 対象終了年
         * @param {number} targetEndMonth 対象終了月
         * @param {SupplierForecastFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetSupplierForecastExportData(targetStartYear: number, targetStartMonth: number, targetEndYear: number, targetEndMonth: number, filterItem?: SupplierForecastFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExportDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetSupplierForecastExportData(targetStartYear, targetStartMonth, targetEndYear, targetEndMonth, filterItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierForecastApi.bulkGetSupplierForecastExportData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 仕入先内示テーブルに情報を登録する(bulk)
         * @param {BulkPostSupplierForecastRequest} bulkPostSupplierForecastRequest 登録する仕入先内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkPostSupplierForecast(bulkPostSupplierForecastRequest: BulkPostSupplierForecastRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkPostSupplierForecastResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkPostSupplierForecast(bulkPostSupplierForecastRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierForecastApi.bulkPostSupplierForecast']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 客先内示情報を基に仕入先内示テーブルに情報を登録する
         * @param {BulkPostSupplierForecastByCustomerForecastRequest} bulkPostSupplierForecastByCustomerForecastRequest 登録する仕入先内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkPostSupplierForecastByCustomerForecast(bulkPostSupplierForecastByCustomerForecastRequest: BulkPostSupplierForecastByCustomerForecastRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkPostSupplierForecastResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkPostSupplierForecastByCustomerForecast(bulkPostSupplierForecastByCustomerForecastRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierForecastApi.bulkPostSupplierForecastByCustomerForecast']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 仕入先内示情報テーブルから情報の取得を行う
         * @param {GetSupplierForecastSortTypeEnum} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {number} createdYear 仕入先内示作成年
         * @param {number} createdMonth 仕入先内示作成月
         * @param {string} [sortTarget] どこの列をソート対象にするのかを指定するパラメータ
         * @param {SupplierForecastFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {boolean} [unassignedResponsibleUserFlag] 客先内示固有 担当者未割り当て（検索用）フラグ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierForecast(sortType: GetSupplierForecastSortTypeEnum, limit: number, offset: number, createdYear: number, createdMonth: number, sortTarget?: string, filterItem?: SupplierForecastFilterItem, unassignedResponsibleUserFlag?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSupplierForecastResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierForecast(sortType, limit, offset, createdYear, createdMonth, sortTarget, filterItem, unassignedResponsibleUserFlag, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierForecastApi.getSupplierForecast']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 仕入先内示テーブルに情報を登録する
         * @param {PostSupplierForecastRequest} postSupplierForecastRequest 登録する仕入先内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSupplierForecast(postSupplierForecastRequest: PostSupplierForecastRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostSupplierForecastResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSupplierForecast(postSupplierForecastRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierForecastApi.postSupplierForecast']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 仕入先内示テーブルの担当者情報を更新する
         * @param {PutSupplierForecastResponsibleUserIdRequest} putSupplierForecastResponsibleUserIdRequest 更新する仕入先内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putSupplierForecastResponsibleUserId(putSupplierForecastResponsibleUserIdRequest: PutSupplierForecastResponsibleUserIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutSupplierForecastResponsibleUserIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putSupplierForecastResponsibleUserId(putSupplierForecastResponsibleUserIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupplierForecastApi.putSupplierForecastResponsibleUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupplierForecastApi - factory interface
 * @export
 */
export const SupplierForecastApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupplierForecastApiFp(configuration)
    return {
        /**
         * 
         * @summary Excelファイルに出力する情報を取得する(bulk)
         * @param {number} targetStartYear 対象開始年
         * @param {number} targetStartMonth 対象開始月
         * @param {number} targetEndYear 対象終了年
         * @param {number} targetEndMonth 対象終了月
         * @param {SupplierForecastFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSupplierForecastExportData(targetStartYear: number, targetStartMonth: number, targetEndYear: number, targetEndMonth: number, filterItem?: SupplierForecastFilterItem, options?: any): AxiosPromise<GetExportDataResponse> {
            return localVarFp.bulkGetSupplierForecastExportData(targetStartYear, targetStartMonth, targetEndYear, targetEndMonth, filterItem, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 仕入先内示テーブルに情報を登録する(bulk)
         * @param {BulkPostSupplierForecastRequest} bulkPostSupplierForecastRequest 登録する仕入先内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkPostSupplierForecast(bulkPostSupplierForecastRequest: BulkPostSupplierForecastRequest, options?: any): AxiosPromise<BulkPostSupplierForecastResponse> {
            return localVarFp.bulkPostSupplierForecast(bulkPostSupplierForecastRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 客先内示情報を基に仕入先内示テーブルに情報を登録する
         * @param {BulkPostSupplierForecastByCustomerForecastRequest} bulkPostSupplierForecastByCustomerForecastRequest 登録する仕入先内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkPostSupplierForecastByCustomerForecast(bulkPostSupplierForecastByCustomerForecastRequest: BulkPostSupplierForecastByCustomerForecastRequest, options?: any): AxiosPromise<BulkPostSupplierForecastResponse> {
            return localVarFp.bulkPostSupplierForecastByCustomerForecast(bulkPostSupplierForecastByCustomerForecastRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 仕入先内示情報テーブルから情報の取得を行う
         * @param {GetSupplierForecastSortTypeEnum} sortType ソートの種類（asc/desc）
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {number} createdYear 仕入先内示作成年
         * @param {number} createdMonth 仕入先内示作成月
         * @param {string} [sortTarget] どこの列をソート対象にするのかを指定するパラメータ
         * @param {SupplierForecastFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {boolean} [unassignedResponsibleUserFlag] 客先内示固有 担当者未割り当て（検索用）フラグ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierForecast(sortType: GetSupplierForecastSortTypeEnum, limit: number, offset: number, createdYear: number, createdMonth: number, sortTarget?: string, filterItem?: SupplierForecastFilterItem, unassignedResponsibleUserFlag?: boolean, options?: any): AxiosPromise<GetSupplierForecastResponse> {
            return localVarFp.getSupplierForecast(sortType, limit, offset, createdYear, createdMonth, sortTarget, filterItem, unassignedResponsibleUserFlag, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 仕入先内示テーブルに情報を登録する
         * @param {PostSupplierForecastRequest} postSupplierForecastRequest 登録する仕入先内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSupplierForecast(postSupplierForecastRequest: PostSupplierForecastRequest, options?: any): AxiosPromise<PostSupplierForecastResponse> {
            return localVarFp.postSupplierForecast(postSupplierForecastRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 仕入先内示テーブルの担当者情報を更新する
         * @param {PutSupplierForecastResponsibleUserIdRequest} putSupplierForecastResponsibleUserIdRequest 更新する仕入先内示テーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSupplierForecastResponsibleUserId(putSupplierForecastResponsibleUserIdRequest: PutSupplierForecastResponsibleUserIdRequest, options?: any): AxiosPromise<PutSupplierForecastResponsibleUserIdResponse> {
            return localVarFp.putSupplierForecastResponsibleUserId(putSupplierForecastResponsibleUserIdRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupplierForecastApi - object-oriented interface
 * @export
 * @class SupplierForecastApi
 * @extends {BaseAPI}
 */
export class SupplierForecastApi extends BaseAPI {
    /**
     * 
     * @summary Excelファイルに出力する情報を取得する(bulk)
     * @param {number} targetStartYear 対象開始年
     * @param {number} targetStartMonth 対象開始月
     * @param {number} targetEndYear 対象終了年
     * @param {number} targetEndMonth 対象終了月
     * @param {SupplierForecastFilterItem} [filterItem] フィルター対象の項目と情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierForecastApi
     */
    public bulkGetSupplierForecastExportData(targetStartYear: number, targetStartMonth: number, targetEndYear: number, targetEndMonth: number, filterItem?: SupplierForecastFilterItem, options?: RawAxiosRequestConfig) {
        return SupplierForecastApiFp(this.configuration).bulkGetSupplierForecastExportData(targetStartYear, targetStartMonth, targetEndYear, targetEndMonth, filterItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 仕入先内示テーブルに情報を登録する(bulk)
     * @param {BulkPostSupplierForecastRequest} bulkPostSupplierForecastRequest 登録する仕入先内示テーブル情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierForecastApi
     */
    public bulkPostSupplierForecast(bulkPostSupplierForecastRequest: BulkPostSupplierForecastRequest, options?: RawAxiosRequestConfig) {
        return SupplierForecastApiFp(this.configuration).bulkPostSupplierForecast(bulkPostSupplierForecastRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 客先内示情報を基に仕入先内示テーブルに情報を登録する
     * @param {BulkPostSupplierForecastByCustomerForecastRequest} bulkPostSupplierForecastByCustomerForecastRequest 登録する仕入先内示テーブル情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierForecastApi
     */
    public bulkPostSupplierForecastByCustomerForecast(bulkPostSupplierForecastByCustomerForecastRequest: BulkPostSupplierForecastByCustomerForecastRequest, options?: RawAxiosRequestConfig) {
        return SupplierForecastApiFp(this.configuration).bulkPostSupplierForecastByCustomerForecast(bulkPostSupplierForecastByCustomerForecastRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 仕入先内示情報テーブルから情報の取得を行う
     * @param {GetSupplierForecastSortTypeEnum} sortType ソートの種類（asc/desc）
     * @param {number} limit 情報の表示最大数
     * @param {number} offset 表示する情報のオフセット
     * @param {number} createdYear 仕入先内示作成年
     * @param {number} createdMonth 仕入先内示作成月
     * @param {string} [sortTarget] どこの列をソート対象にするのかを指定するパラメータ
     * @param {SupplierForecastFilterItem} [filterItem] フィルター対象の項目と情報
     * @param {boolean} [unassignedResponsibleUserFlag] 客先内示固有 担当者未割り当て（検索用）フラグ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierForecastApi
     */
    public getSupplierForecast(sortType: GetSupplierForecastSortTypeEnum, limit: number, offset: number, createdYear: number, createdMonth: number, sortTarget?: string, filterItem?: SupplierForecastFilterItem, unassignedResponsibleUserFlag?: boolean, options?: RawAxiosRequestConfig) {
        return SupplierForecastApiFp(this.configuration).getSupplierForecast(sortType, limit, offset, createdYear, createdMonth, sortTarget, filterItem, unassignedResponsibleUserFlag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 仕入先内示テーブルに情報を登録する
     * @param {PostSupplierForecastRequest} postSupplierForecastRequest 登録する仕入先内示テーブル情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierForecastApi
     */
    public postSupplierForecast(postSupplierForecastRequest: PostSupplierForecastRequest, options?: RawAxiosRequestConfig) {
        return SupplierForecastApiFp(this.configuration).postSupplierForecast(postSupplierForecastRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 仕入先内示テーブルの担当者情報を更新する
     * @param {PutSupplierForecastResponsibleUserIdRequest} putSupplierForecastResponsibleUserIdRequest 更新する仕入先内示テーブル情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplierForecastApi
     */
    public putSupplierForecastResponsibleUserId(putSupplierForecastResponsibleUserIdRequest: PutSupplierForecastResponsibleUserIdRequest, options?: RawAxiosRequestConfig) {
        return SupplierForecastApiFp(this.configuration).putSupplierForecastResponsibleUserId(putSupplierForecastResponsibleUserIdRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetSupplierForecastSortTypeEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetSupplierForecastSortTypeEnum = typeof GetSupplierForecastSortTypeEnum[keyof typeof GetSupplierForecastSortTypeEnum];


